
export enum FilterByDto{
  DATE,
  POPULARITY,
  FOLLOW,
  SUBMITTED
}
